<template>
  <div class="width-date-picker">
    <el-form
      label-position="top"
      :model="form"
      :rules="rules"
      ref="form"
      class="text-left"
    >
      <el-row :gutter="30">
        <el-col :span="24">
          <el-form-item
            label="ชื่อหัวข้องานที่ได้รับมอบหมาย (Assignment)"
            prop="assignmentName"
          >
            <el-input v-model="form.assignmentName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="12">
          <el-form-item
            label="ระยะเวลาในการเปิด-ปิดการส่งงานที่ได้รับมอบหมาย (Assignment) "
            prop="assignmentDistanceDate"
            class="line-unset"
          >
            <el-date-picker
              v-model="form.assignmentDistanceDate"
              type="daterange"
              class="width-100 show-in-desktop"
              range-separator="ถึง"
              start-placeholder
              end-placeholder
              format="d MMMM yyyy"
              :picker-options="{
                disabledDate(time) {
                  return (
                    time.getTime() < new Date(startDate).getTime() ||
                    time.getTime() > new Date(endDate).getTime()
                  );
                },
              }"
            ></el-date-picker>
            <div class="flex-display js-between show-in-desktop">
              <span class="color-gray line-initial text-font-12">เวลา 0.00 น.</span>
              <span class="color-gray line-initial text-font-12">เวลา 23.59 น.</span>
            </div>

            <el-date-picker
              v-model="form.assignmentDistanceDate[0]"
              type="date"
              format="d MMMM yyyy"
              class="show-in-mobile width-100"
              :picker-options="{
                disabledDate(time) {
                  return (
                    time.getTime() >
                      new Date(form.assignmentDistanceDate[1]).getTime() ||
                    time.getTime() < new Date(startDate).getTime() ||
                    time.getTime() > new Date(endDate).getTime()
                  );
                },
              }"
            >
            </el-date-picker>
            <span class="color-gray line-initial text-font-12 show-in-mobile">เวลา 0.00 น.</span>

            <el-date-picker
              v-model="form.assignmentDistanceDate[1]"
              type="date"
              format="d MMMM yyyy"
              class="show-in-mobile mg-t-4 width-100"
              :picker-options="{
                disabledDate(time) {
                  return (
                    time.getTime() <
                      new Date(form.assignmentDistanceDate[0]).getTime() ||
                    time.getTime() < new Date(startDate).getTime() ||
                    time.getTime() > new Date(endDate).getTime()
                  );
                },
              }"
            >
            </el-date-picker>
            <span class="color-gray line-initial text-font-12 show-in-mobile">เวลา 23.59 น.</span>
          </el-form-item>
          
        </el-col>

        <el-col :span="24">
          <el-form-item label="รายละเอียดงานที่ได้รับมอบหมาย (Assignment)">
            <yimo-vue-editor
              v-model="form.assignmentDescription"
              @input="clearText(form.assignmentDescription)"
            ></yimo-vue-editor>
          </el-form-item>
        </el-col>

        <el-col :span="24" >
          <el-form-item label="แนบไฟล์งานที่ได้รับมอบหมาย (Assignment) (รองรับไฟล์ .jpg, .jpeg, .png, doc, .docx, .xls, .xlsx, .pdf, .ppt, .pptx  ขนาดไม่เกิน 25 MB )">
            <div v-for="(item, index) in form.assignmentFile" :key="index">
              <el-upload
                v-if="item.name == ''"
                class="upload-input-text"
                :class="{ 'pd-t-4': index > 0 }"
                action="#"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="(file) => uploadAssignmentFile(file, index)"
              >
                <template slot="trigger">
                  <div class="flex-display ai-center file-input">
                    <el-input v-model="item.name" class></el-input>
                    <el-button type="primary" class="light mg-l-4"
                      >แนบไฟล์</el-button
                    >
                  </div>
                </template>
              </el-upload>

              <span v-else class="text-font-12 pd-l-5 mg-y-less">
                <span
                  :href="`#`"
                  target="blank"
                  class="color-primary-light text-underline"
                >
                  {{
                    typeof item.name != "undefined" ? item.name : item.default
                  }}
                </span>
                <i
                  @click="delAssignmentFile(index)"
                  class="fas fa-times-circle color-gray-lighter pd-l-5 cursor-pointer"
                ></i>
              </span>
            </div>

            <a @click="addAssignmentFile" class="color-primary-light"
              >+ เพิ่มไฟล์งานที่ได้รับมอบหมาย (Assignment)</a
            >
          </el-form-item>
        </el-col>
      </el-row>

      <div class="text-center pd-y-3">
        <el-button
          v-if="type == 'add'"
          @click="createAssignment"
          type="primary"
          round
          class="pd-x-1"
          >เพิ่มงานที่ได้รับมอบหมาย</el-button
        >
        <el-button
          v-if="type == 'update'"
          @click="updateAssignment"
          type="primary"
          round
          class="pd-x-1"
          >บันทึก</el-button
        >
      </div>
    </el-form>
  </div>
</template>

<script>
import { clearText } from "@/service/editor";
import { isFileDocumnet } from "@/service/file";

export default {
  props: {
    type: {
      type: String,
      default() {
        return "add";
      },
    },
    startDate: {
      type: String,
      default() {
        return "";
      },
    },
    endDate: {
      type: String,
      default() {
        return "";
      },
    },
    assignment: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      form: {
        assignmentName: "",
        assignmentDistanceDate: [],
        assignmentDescription: "",
        assignmentFile: [{ name: "", type: "" }],
      },
      rules: {
        assignmentName: [
          {
            required: true,
            message: "กรุณากรอกชื่อหัวข้องานที่ได้รับมอบหมาย",
            trigger: "blur",
          },
        ],
        assignmentDistanceDate: [
          {
            required: true,
            message: "กรุณาเลือกระยะเวลาในการเปิด-ปิดการส่งงานที่ได้รับมอบหมาย",
            trigger: ["blur", "change"],
          },
        ],
      },
      assignmentId: "",
      assignmentFileDel: [],
    };
  },
  watch: {
    assignment() {
      this.setAssignment();
    },
  },
  mounted() {
    this.setAssignment();
  },
  methods: {
    setAssignment() {
      if (this.assignment != null) {
        this.form = {
          assignmentName: this.assignment.name,
          assignmentDistanceDate:typeof this.assignment.durationTime != 'undefined' && this.assignment.durationTime.open? [
            this.assignment.durationTime.open,
            this.assignment.durationTime.close,
          ]:[],
          assignmentDescription: this.assignment.description,
          assignmentFile: this.assignment.attach,
        };

        this.assignmentId = this.assignment._id;
      }
    },
    createAssignment() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$emit("createAssignment", this.form);
        }
      });
    },
    updateAssignment() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let obj = {
            assignmentFileDel: this.assignmentFileDel,
          };
          this.$emit("updateAssignment", this.form, obj, this.assignmentId);
        }
      });
    },
    uploadAssignmentFile(file, index) {
      var sizeInMB = (file.size / (1024*1024)).toFixed(2);
      if (!this.isFileDocumnet(file.name)) {
        this.$message.error("ไม่รองรับไฟล์ที่อัพโหลด");
      } else if(sizeInMB > 25){
        this.$message.error("ไฟล์ที่อัพโหลดขนาดใหญ่เกินกว่าที่รองรับ");
      }else {
        this.form.assignmentFile[index].name = file.name;
        this.form.assignmentFile[index].type = file.raw.type;
        this.form.assignmentFile[index] = file;
      }
    },
    addAssignmentFile() {
      this.form.assignmentFile.push({ name: "", type: "" });
    },
    delAssignmentFile(index) {
      if (typeof this.form.assignmentFile[index].name == "undefined") {
        this.assignmentFileDel.push(this.form.assignmentFile[index].file);
      }
      this.form.assignmentFile.splice(index, 1);
    },
    
  },
};
</script>

<style scoped>
</style>
